import { render, staticRenderFns } from "./location-field.vue?vue&type=template&id=1c43bf7c"
import script from "./location-field.vue?vue&type=script&lang=js"
export * from "./location-field.vue?vue&type=script&lang=js"
import style0 from "./location-field.vue?vue&type=style&index=0&id=1c43bf7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports